<div class="list-dynamic">
  <div class="list-dynamic_header" *ngIf="componentTitle || addButton">
    <div>
      <div *ngIf="componentTitle" class="{{componentTitleClass}}">
        <span>{{componentTitle | translate}}</span>
      </div>
    </div>
    <div>
      <button siPreventDoubleClick
              *ngIf="addButton"
              type="button"
              class="si-button"
              (click)="onClickAddRow()"
              [disabled]="addButtonDisabled">
        <i *ngIf="iconClass" class="{{iconClass}} mr-2"></i>
        <span translate="{{addButtonText}}"></span>
      </button>
    </div>
  </div>
  <ng-content></ng-content>
</div>
